<template>
  <div>
    <div style="height: 100px" v-loading="true">

    </div>
    <div style="text-align: center;font-size: 16px;padding-bottom: 30px">
      <span>VIN码正在识别中...</span>
    </div>
  </div>
</template>

<script>
import server from "@/utils/server";
export default {
  name: "VinLoading",
  props: ["vinCode"],
  data() {
    return {
      dialogVisible: true,
    };
  },
  created() {

  },
  mounted() {
    setTimeout(()=>{
      console.log("vinLoading....")
      this.pollingVin()
    },1000)
  },
  methods:{
    pollingVin(){
      var _this = this
      server
          .myAxios("/api/SearchAuto/PollingIsVinSuccess", {
            vinCode:_this.vinCode
          })
          .then((res) => {
            //do nothing
            if (res.status == 1) {
              _this.$emit("success",this.vinCode)
            }else if (res.status == -1) {
              _this.$emit("fail")
            }else {
              setTimeout(()=>{
                _this.pollingVin()
              },3000)
            }
          });
    }
  }
};
</script>

<style scoped>

</style>
